import React from 'react';
import { Link } from 'react-router-dom';
const HeroSection = () => {
  return <section className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white" data-id="element-232">
      <div className="absolute inset-0 bg-black opacity-30" data-id="element-233"></div>
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1607083206968-13611e3d76db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2215&q=80')",
      opacity: 0.2
    }} data-id="element-234"></div>
      <div className="container mx-auto px-4 py-24 md:py-32 relative z-10" data-id="element-235">
        <div className="max-w-3xl" data-id="element-236">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-237">
            Shop Unique Products from Trusted Sellers
          </h1>
          <p className="text-xl md:text-2xl mb-8" data-id="element-238">
            Your one-stop marketplace for quality products from verified
            merchants.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-239">
            <Link to="/categories" className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold text-lg hover:bg-gray-100 transition duration-200" data-id="element-240">
              Shop Now
            </Link>
            <Link to="/become-seller" className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-full font-semibold text-lg hover:bg-white hover:text-blue-600 transition duration-200" data-id="element-241">
              Become a Seller
            </Link>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;